export const GET_WORKFLOW_FUNDS = "/workflows/:workflowId/funds/:tag/";
export const MOVE_WORKFLOW_FUND_STATE = "/workflows/state_movement/:workflowFundId/";
export const GET_WORKFLOW_FUNDS_UPDATE = "/workflows/:workflowId/poll_state/:tag/";
export const ADD_WORKFLOW_FUND_NOTE = "/workflows/member-workflows/:workflowFundId/notes/";
export const GET_WORKFLOW_FUND_NOTES = "/workflows/member-workflows/:workflowFundId/notes/";
export const COMPLETE_WORKFLOW_FUND_NOTE = "/workflows/notes/:noteId/";
export const UPDATE_WORKFLOW_PERSON = "/workflows/member-workflows/:workflowFundId/";
export const GET_WORKFLOWS = "/workflows/";
